var render = function (_h,_vm) {
var _obj;
var _c=_vm._c;return _c('div',{class:( _obj = {
        'loading-wrapper': true,
        'loading-wrapper--is-loading': _vm.props.loading
    }, _obj[("loading-wrapper--" + (_vm.props.bgColor))] = _vm.props.bgColor, _obj )},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }